import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs';
import {
  DestroyRef, Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  Output,
  EventEmitter,
  inject,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ButtonComponent } from '@ppl/ui';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzInputModule } from 'ng-zorro-antd/input';
import { BaseComponent } from '../../../../shared/utils/base.component';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { CommonModule, DatePipe } from '@angular/common';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { STATIC_JSON_DATA_PATH } from '../../../../shared/constants/static-data.constants';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { SectionsService } from '../../../../services/sections.service';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import {  ListTableComponent  } from '@ppl/ui';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { GridAction } from '@ppl/ui';
import { ListService } from '../../../../shared/services/list.service';
import { AuthorizationsDetailsService } from '../../../../services/authorizations-service.service';
import { performValidation } from '../../../../shared/utils/validation.util';
import { LoggerService } from '../../../../shared/services/logger.service';
import { SharedService } from '../../../../shared/services/shared.service';
import { FileUploadComponent } from '../../../lead-details/documents/file-upload/file-upload/file-upload.component';
import { LookupValueItem } from '../../../../interfaces/lookup.interface';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { ClaimsService } from '../../../../services/claims.service';
import { DialogService, DialogConfig } from '../../../../shared/services/dialog.service';
import { SearchAddDiagnosisCodeComponent } from '../search-add-diagnosis-code/search-add-diagnosis-code.component';
import { UserService } from '../../../../services/user.service';
import { DatepickerComponent } from '@ppl/ui';
import { FocusTrapDirective } from '../../../../shared/directives/focus-trap.directive';
import { DropdownSelectComponent } from '@ppl/ui';
import { ProviderService } from '../../../../services/provider.service';
import { MultiselectComponent } from '@ppl/ui';
import { AuthAllocationListComponent } from '../auth-allocation-list/auth-allocation-list.component';
import { Router } from '@angular/router';
import { AuthorizationService } from '../../../auth-usage-charts/services/authorization.service';
import { ConsumerAuthList } from '../../../auth-usage-charts/models/authorization.model';
import { RealNumberOnlyDirective } from 'src/app/shared/directives/real-number-only.directive';
import { AllowListAuthStore } from '../../../../shared/authorization/allow-list-auth.store';
import { PAGE_CONSTANTS, AUTHORIZATION_EDIT_SPENDING_PLAN_ACTION } from '../../../../shared/constants/page.constants';
@Component({
  selector: 'ppl-auth-forms',
  standalone: true,
  imports: [
    ButtonComponent,
    NzFormModule,
    ReactiveFormsModule,
    FormsModule,
    NzCardModule,
    NzInputModule,
    NzToolTipModule,
    CommonModule,
    NzDatePickerModule,
    NzToolTipModule,
    NzSelectModule,
    NzButtonModule,
    NzCollapseModule,
    NzAutocompleteModule,
    ListTableComponent,
    FileUploadComponent,
    SearchAddDiagnosisCodeComponent,
    DatepickerComponent,
    FocusTrapDirective,
    RealNumberOnlyDirective,
    DropdownSelectComponent,
    AuthAllocationListComponent
  ],
  providers: [ListService],
  templateUrl: './auth-forms.component.html',
  styleUrl: './auth-forms.component.css',
})
export class AuthFormsComponent
  extends BaseComponent
  implements OnInit, OnChanges {
  // Unsubscribes from the shared AuthorizationsDetailsService flags when this component is destroyed.
  private readonly destroyRef = inject(DestroyRef);
  authorizationsForm!: FormGroup;
  providerTypes: any;
  pageTitle = 'Add Authorization';
  mode = 'read';
  savedData: any = {};
  isNew = true;
  isConsumerSelected = false;
  showConsumersList = false;
  programName!: string;
  columnsToBeHidden: any;
  sharedDataKey: any;
  actionsToBeHidden: any;
  lazyLoad = true;
  cols: any[] = [];
  authCols: any[] = [];
  flow: string | null = '';
  selectedConsumer: any;
  consumerAuthData: any = {};
  selectedAuth: any;
  showSearchError = false;
  mcoEntries: any = [];
  serviceCoordinator: any = [];
  showAddedAuths = false;
  modifiersList: any;
  serviceCodesList: any = [];
  authsInSession: any[] = [];
  filedInfo: any;
  selectedLead = 0;
  savedAuthId: any;
  isFormDisabled = false;
  control: any;
  authFrequencyTypeList: LookupValueItem[] = [];
  /** authData arrived before the FormGroup existed; ngOnInit replays the patch. */
  private patchPending = false;
  authTypeList: LookupValueItem[] = [];
  radioOptions: LookupValueItem[] = [];
  inputDiagnosisValue?: string;
  filteredDiagnosisOptions: any[] = [];
  filteredDiagnosisOptions1: any[] = [];
  filteredDiagnosisOptions2: any[] = [];
  filteredDiagnosisOptions3: any[] = [];
  override daysOfWeek: string[] = ['Sun', 'Mon', 'Tues', 'Wed', 'Thu', 'Fri', 'Sat'];
  minSteps = ['00', '15', '30', '45'];
  actionButtons: TableRowActionsModel = new TableRowActions({ add: true });
  disableDate = false;
  minStartDate?: Date;
  maxEndDate?: Date;
  isNewAuthCreationMode = false;
  isNewAuthSubmitted = false;
  isExistingAuthUpdate = false;
  isProviderAuthAllocated = false;

  @Input() formState = 'edit';
  @Input() authData: any;
  @Input() authAdded = false;
  @Input() disableForm = true;
  @Input() actionMode = 'read'
  @Input() from: any;
  /** Auth being viewed/edited; passed by ppl-authorization-details so the shared selected lead isn't read. */
  @Input() authorizationId: any;
  /** Flow of the hosting authorization details; falls back to the shared flow when not passed. */
  @Input() contextFlow?: string;
  @Output() authSubmitted = new EventEmitter<boolean>();
  @Output() authUpdate = new EventEmitter<boolean>();
  @ViewChild('diagnosisListDialog') diagnosisListDialog!: TemplateRef<any>;
  @ViewChild('addAuthSpendingPlan') addAuthSpendingPlan!: TemplateRef<any>;
  @ViewChild('approvedAuthconfirmationDialog') approvedAuthconfirmationDialog!: TemplateRef<any>;
  private dialogSvc = inject(DialogService);
  private allowListStore = inject(AllowListAuthStore);
  dialogId: any;
  addDialogId: any;
  isPatching = false;
  codeForUnits: any;
  authSourceList: any;
  gridData: any[] = [];
  providers: any[] = [];
  svcAdminList: any;
  unitTypeList: any;
  spendingPlans: any[] = [];
  spendingPlan: string = '';
  // Granted via the role allow-list (I&A L1-3, CS Escalations, PPL Admin)
  canEditSpendingPlan = false;

  constructor(
    private fb: FormBuilder,
    private sectionsService: SectionsService,
    private listService: ListService,
    private authorizationService: AuthorizationsDetailsService,
    private datePipe: DatePipe,
    private logger: LoggerService,
    private sharedService: SharedService,
    private claimsService: ClaimsService,
    private userService: UserService,
    private providerService: ProviderService,
    private router: Router,
    private authService: AuthorizationService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.canEditSpendingPlan = this.allowListStore.isActionAllowed(
      PAGE_CONSTANTS.AUTHORIZATION_DATA_GRID_PAGE,
      AUTHORIZATION_EDIT_SPENDING_PLAN_ACTION
    );
    this.authorizationsForm = this.fb.group({
      consumerFirstName: [''],
      consumerLastName: [''],
      medicaid: [''],
      consumerPPLId: [''],
      pplAuth: [''],
      clientAuth: [''],
      serviceCode: [null],
      diagnosisIdValue: [{ value: null, disabled: true }],
      planId: [{ value: null, disabled: true }],
      serviceAdminLkp: [null],
      serviceDescription: [''],
      units: [null],
      startDate: [''],
      endDate: [''],
      orgName: [null],
      source: [null],
      decisionBy: [null],
      sourceDetail: [null],
      statusLkp: [null],
      decisionComments: [null],
      // Plain value, not { value: ... }: Angular only treats an object as control state when it has
      // exactly the two keys `value` and `disabled` (isFormControlState). With `value` alone the
      // object itself became the control's value, so the dropdown had nothing matching an option's
      // lkpValueName and fell back to the placeholder on the add flow.
      authFrequencyLkp: ['Entire Period'],
      carryoverUnits: [null],
      sunHrs: [null],
      monHrs: [null],
      tuesHrs: [null],
      wedHrs: [null],
      thuHrs: [null],
      friHrs: [null],
      satHrs: [null],
      dailyUnits: this.fb.array((this.createDays())
      ),
      totalAuthUnitsHrs: [null],
      totalAuthUnitsMin: ['00'],
      totalAuthUnits: [{ value: null, disabled: true }],
      estimatedFirstWeekUnits: [null],
      estimatedMidWeekUnits: [null],
      estimatedLastWeekUnits: [null],
      weeklyAuthUnitsFormatted: [null],
      serviceCoordinator: [null],
      comments: [null],
      categoryLkp: [null]
    });

    const program = this.userService.getSelectedProgram();
    this.flow = this.contextFlow || (this.sectionsService.getFlow() ?? '');
    // In the add flow there is no selected auth yet; the shared selected-lead may still hold a
    // previously viewed auth's id, which must not be used for updates (savedAuthId is used instead).
    this.selectedAuth = this.formState === 'add' ? undefined : (this.authorizationId ?? this.userService.getSelectedLead());
    this.programName = program?.program_code ?? '';
    this.secData = this.sectionsService.getSectionData(
      program?.program_code,
      'payroll',
      undefined,
      this.flow
    );
    if (this.authData?.participantId) {
      this.consumerAuthData.authId = this.authData.authorizationId;
      this.consumerAuthData.participantId = this.authData.participantId;
      this.consumerAuthData.startDate = this.authData.startDate;
      this.consumerAuthData.endDate = this.authData.endDate;
      this.consumerAuthData.units = this.authData.units;
      this.getProviders(this.authData?.participantId);
      this.getSpendingPlans(this.authData?.participantId, true);
    }
    this.getLookupValues();
    this.getServiceData();
    this.providerTypes = this.getLookup('ProviderType');
    this.svcAdminList = this.getLookup('Waiver').filter((value: any) => value.lkpValueCode === 'Health Plan');
    this.unitTypeList = this.getLookup('Utype');
    this.authSourceList = this.getLookup('AuthS').filter((value: any) => value.lkpValueCode !== 'File' && value.lkpValueCode !== 'MCO' && value.lkpValueCode !== 'T4C');
    this.authFrequencyTypeList = this.getLookup('AFT');
    this.radioOptions = this.getLookup('Yes_No');
    this.getGridHeaders();
    this.getAuthGridHeaders();
    this.authorizationsForm.get('endDate')?.valueChanges.subscribe(() => {
      this.updateMinStartDate();
      // The period length feeds totalAuthUnits for every frequency except Entire Period.
      this.applyTotalAuthUnits();
    });
    this.authorizationsForm.get('startDate')?.valueChanges.subscribe(() => {
      this.updateMaxEndDate();
      this.applyTotalAuthUnits();
    });
    // "Authorized Dollars" can be typed directly as well as derived from the hours/minutes inputs,
    // so watch the control itself rather than only those handlers.
    this.authorizationsForm.get('units')?.valueChanges.subscribe(() => {
      this.applyTotalAuthUnits();
    });
    this.lockCalculatedFields();

    if (this.disableForm) {
      this.authorizationsForm.disable();
      this.disableDate = true;
      this.patchAuthDetails();
    }
    if (this.mode === 'edit') {
      this.disableFieldsForEdit();
      this.patchAuthDetails();
    }
    // A patch requested from ngOnChanges before the form existed — replay it now that the form and
    // the AFT lookup list are both ready.
    if (this.patchPending) {
      this.patchAuthDetails();
    }
    this.authorizationService.getDocUpload().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((docUpload: any) => {
      if (docUpload) {
        // this.authorizationsForm.reset();
        this.authorizationsForm.disable();
        this.disableDate = true;
      }
    });

    this.authorizationService.getAddMoreAuth().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((addMoreAuth: any) => {
      if (addMoreAuth) {
        this.authAdded = false;
        this.mode = 'add';
      }
    });

    // A clone only applies to the add flow, and only once: consume it and clear it so it can't
    // replay into a later details/edit view of this component.
    const clonedAuth$ = this.formState === 'add'
      ? this.authorizationService.getClonedAuthorization().pipe(take(1))
      : null;
    clonedAuth$?.subscribe((clonedAuth: any) => {
      if (clonedAuth) {
        this.authorizationService.clearClonedAuthorization();
        if (!this.providers || this.providers.length === 0) {
          this.getProviders(clonedAuth?.participantId, true);
        }
        // Spending plans aren't pre-loaded for the clone flow — without this fetch the
        // patched clientAuth has nothing to match against in the dropdown.
        this.getSpendingPlans(clonedAuth?.participantId, true);

        this.authAdded = false;
        this.mode = 'add';
        this.selectedConsumer = {
          arialabel: `${clonedAuth?.consumerFirstName} ${clonedAuth?.consumerLastName} - CIN: ${clonedAuth?.medicaid} - PPL ID: ${clonedAuth?.consumerPPLId}`,
          consumerFirstName: clonedAuth?.consumerFirstName ?? "",
          consumerLastName: clonedAuth?.consumerLastName ?? "",
          consumerPPLId: clonedAuth?.consumerPPLId ?? "",
          medicaid: clonedAuth?.medicaid ?? "",
          participantId: clonedAuth?.participantId ?? null
        };

        this.isConsumerSelected = true;
        this.authData = clonedAuth;
        this.authData.startDate = this.dateFormatter.formatStringToDate(clonedAuth.startDate);
        this.authData.endDate = this.dateFormatter.formatStringToDate(clonedAuth.endDate);
        this.patchAuthDetails();
      }
    });
  }

  onInputBlur(val?: string, event?: any, i?: number, day?: any) {
    const dailyHours = this.authorizationsForm.get('dailyUnits')?.value;
    // const codeSelected = this.authorizationsForm.get('serviceCode')?.value;
    let totalUnits = 0;
    dailyHours.forEach((entry: any) => {
      const hoursUnits = entry.hours * 4;
      const minutesUnits = entry.minutes ? entry.minutes / 15 : 0;
      totalUnits += hoursUnits + minutesUnits;
    });
    // if (this.codeForUnits?.includes(codeSelected)) {
    //   this.authorizationsForm.get('units')?.setValue(26);
    // } else {
    this.authorizationsForm.get('units')?.setValue(totalUnits);
    // }
  }


  getProviders(consumerId: string, forcePatch: boolean = false) {
    this.providerService
      .getProviderList(this.programName, consumerId)
      .subscribe((data: any) => {
        this.providers = data.responsedata;

        if (forcePatch) {
          this.patchAuthDetails();
        }
      });
  }

  serviceCodeChanged(event: any) {
    if (!this.isPatching) {
      const service = this.serviceCodesList.filter((code: any) => code.servicecodeDetailId === event);
      this.authorizationsForm.get('serviceDescription')?.setValue(service[0]?.serviceDescription);
    }
  }

  authFreqChanged() {
    if (this.authorizationsForm.get('totalAuthUnitsHrs')) {
      this.authorizationsForm.get('totalAuthUnitsHrs')?.reset();

    }
    if (!this.isPatching) {
      this.authorizationsForm.get('units')?.setValue(0);
      this.authorizationsForm.get('totalAuthUnitsMin')?.setValue('00');
      const dailyUnitsArray = this.authorizationsForm.get('dailyUnits') as FormArray;

      dailyUnitsArray.controls.forEach((control, index) => {
        if (control instanceof FormGroup) {
          control.get('hours')?.reset();
          control.get('minutes')?.setValue('00');
        }
      });
      //this.authorizationsForm.get('dailyUnits')?.reset();
    }

    // Changing frequency changes the multiplier, so the total is always stale here.
    this.applyTotalAuthUnits();
  }

  getServiceData() {
    this.claimsService.getServiceData(this.programName).subscribe((data: any) => {
      this.serviceCodesList = data?.responsedata?.serviceCodes;
      this.mcoEntries = data?.responsedata?.organizations;
      this.codeForUnits = this.serviceCodesList.filter((codeData: any) => codeData.description.includes('T1020')).map((code: any) => code.servicecodeDetailId);
    })
  }

  createDays(): FormGroup[] {
    if (this.from === 'add' || this.mode === 'edit') {
      return this.daysOfWeek.map(() => {
        const dayGroup = this.fb.group({
          hours: ['', [Validators.min(0), Validators.max(24), Validators.pattern('^[0-9]*$')]],
          minutes: ['00']
        });

        dayGroup.get('hours')?.valueChanges.subscribe((hours) => {
          const minutesControl = dayGroup.get('minutes');
          const hoursNumber = Number(hours);

          if (hoursNumber === 24) {
            minutesControl?.setValue('00');
            minutesControl?.disable();
          } else {
            if (this.disableForm && this.from === 'details') {
              minutesControl?.disable();
            } else {
              minutesControl?.enable();
            }
          }
        });
        return dayGroup;
      });
    }
    return this.daysOfWeek.map(() => {
      return this.fb.group({
        hours: [''],
        minutes: ['']
      });
    })
  }

  getControlClass(i: number): string {
    const dailyUnits = this.authorizationsForm.get('dailyUnits') as FormArray;
    const hoursControl = dailyUnits.controls[i]?.get('hours');

    if (!hoursControl) return '';

    if (hoursControl.invalid && hoursControl.touched) {
      return 'ng-invalid-hours';
    } else if (hoursControl.valid) {
      return 'ng-valid-hours';
    }
    return '';
  }

  get dailyUnits(): FormArray {
    return this.authorizationsForm.get('daysToContact') as FormArray;
  }

  getLookupValues(): void {
    this.modifiersList = this.lookupService.getTasLookupValue('modifierDetailList');
    this.authTypeList = this.lookupService.getLookupValue('auth_type');
  }

  onOrgChange(event: any) {
    if (event) {
      const planId = this.mcoEntries.find((org: any) => {
        return org.orgId === event;
      })
      this.authorizationsForm.get('planId')?.setValue(planId?.payerId)
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    try {
      if (changes['formState'] && changes['formState'].currentValue) {
        this.mode = changes['formState'].currentValue;
      }
      if (changes['from'] && changes['from'].currentValue) {
        if (this.from === 'add' && this.authorizationsForm) {
          this.authorizationsForm.enable();
          this.lockCalculatedFields();
          this.disableDate = false;
        }
      }
      if (changes['authData'] && changes['authData'].currentValue) {
        this.patchAuthDetails();
      }
      if (
        changes['disableForm'] &&
        changes['disableForm'].currentValue !==
        changes['disableForm'].previousValue
      ) {
        if (this.disableForm && this.authorizationsForm) {
          this.authorizationsForm.disable();
          this.disableDate = true;
          this.patchAuthDetails();
        } else if (!this.disableForm && this.authorizationsForm) {
          this.mode = 'edit';
          this.authorizationsForm.enable();
          this.lockCalculatedFields();
          this.disableDate = false;
          this.disableFieldsForEdit();
          this.patchAuthDetails();
        }
      }
    } catch (e) {
      console.log('Error in getting section data and updating latest info', e);
    }
  }

  onAuthUnitMinChange(event: any) {
    if (event) {
      let authHr = this.authorizationsForm.get('totalAuthUnitsHrs')?.value;
      // const codeSelected = this.authorizationsForm.get('serviceCode')?.value;
      if (!authHr && event) {
        authHr = 0;
      }
      // HHMM is only an intermediate for deriving per-occurrence units; totalAuthUnits now holds
      // the frequency-multiplied total instead.
      const enteredTime = authHr.toString().padStart(2, '0') + event?.toString().padStart(2, '0');
      const totalUnits = this.timeToUnits(enteredTime);
      // if (this.codeForUnits?.includes(codeSelected)) {
      //   this.authorizationsForm.get('units')?.setValue(26);
      // } else {
      this.authorizationsForm.get('units')?.setValue(totalUnits);
      // }
      // No applyTotalAuthUnits() here — setValue above emits, and the units subscription in
      // ngOnInit recomputes the total.
    }
  }

  onAuthUnitHrChange(event: any) {
    if (event || event === 0) {
      let authMin = this.authorizationsForm.get('totalAuthUnitsMin')?.value;
      // const codeSelected = this.authorizationsForm.get('serviceCode')?.value;
      if (!authMin && event) {
        authMin = 0;
      }
      const enteredTime = event?.toString().padStart(2, '0') + authMin?.toString().padStart(2, '0');
      const totalUnits = this.timeToUnits(enteredTime);
      // if (this.codeForUnits?.includes(codeSelected)) {
      //   this.authorizationsForm.get('units')?.setValue(26);
      // } else {
      this.authorizationsForm.get('units')?.setValue(totalUnits);
      // }
      // No applyTotalAuthUnits() here — setValue above emits, and the units subscription in
      // ngOnInit recomputes the total.
    }
  }

  limitDigits(event: any): void {

    let value = event.target.value.replace(/[^0-9]/g, '');
    event.target.value = value;
    this.authorizationsForm.get('totalAuthUnitsHrs')?.setValue(value);
  }

  limitDailyDigits(event: any): void {

    let value = event.target.value.replace(/[^0-9]/g, '');
    event.target.value = value;
  }

  timeToUnits(time: string): number {
    if (time) {
      const minutes = parseInt(time.slice(-2), 10);
      const hours = parseInt(time.slice(0, -2), 10);
      const totalMinutes = (hours * 60) + minutes;
      const units = Math.floor(totalMinutes / 15);
      return units;
    }
    else {
      return 0;
    }
  }

  // ── Authorization frequency → total units ────────────────────────────────
  // The AFT dropdown binds [optionValue]="'lkpValueName'", so authFrequencyLkp holds the label.
  private readonly AUTH_FREQUENCY = {
    DAILY: 'Daily',
    WEEKLY: 'Weekly',
    MONTHLY: 'Monthly',
    ENTIRE_PERIOD: 'Entire Period',
    SEMI_MONTHLY: 'Semi-Monthly',
  };

  /**
   * How many times the authorized units recur across [startDate, endDate]:
   *   Daily         — one per calendar day, both ends inclusive (01 Jan–30 Jan → 30)
   *   Weekly        — one per Sunday–Saturday calendar week the period overlaps, however
   *                   partially. Aug 2026 (Sat 01 – Mon 31) touches 6 such weeks, because the
   *                   1st falls at the tail of the week beginning Sun 26 Jul and the 30th/31st
   *                   open the week beginning Sun 30 Aug.
   *   Monthly       — one per *started* calendar month; a single day in a month counts as
   *                   that whole month (25 Jan–02 Feb → 2)
   *   Entire Period — the units cover the authorization as a whole → 1
   *
   * Returns 0 when the range is unusable (missing or inverted), so an incomplete form shows 0
   * rather than a misleading figure.
   */
  getFrequencyPeriodCount(frequency: string, start: any, end: any): number {
    if (frequency === this.AUTH_FREQUENCY.ENTIRE_PERIOD) {
      return 1;
    }

    const startDate = this.toDate(start);
    const endDate = this.toDate(end);
    if (!startDate || !endDate) {
      return 0;
    }

    // Compare date-only via Date.UTC so a time-of-day component or a DST boundary inside the
    // range cannot add or drop a day.
    const fromUtc = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    const toUtc = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
    if (toUtc < fromUtc) {
      return 0;
    }
    const dayCount = Math.round((toUtc - fromUtc) / 86400000) + 1;

    switch (frequency) {
      case this.AUTH_FREQUENCY.DAILY:
        return dayCount;
      case this.AUTH_FREQUENCY.WEEKLY:
        // Weeks are Sunday-anchored, so pad the range back to the Sunday that opens the start
        // date's week before dividing. getDay() is 0 for Sunday, which is exactly that offset.
        // Without the padding this counted rolling 7-day blocks from the start date instead.
        return Math.ceil((startDate.getDay() + dayCount) / 7);
      case this.AUTH_FREQUENCY.MONTHLY:
        // Count month boundaries crossed, not 30-day blocks, so any overlap with a calendar
        // month bills as a full month.
        return (endDate.getFullYear() - startDate.getFullYear()) * 12
          + (endDate.getMonth() - startDate.getMonth()) + 1;
      case this.AUTH_FREQUENCY.SEMI_MONTHLY:
        // Count the number of 1st and 15th boundaries crossed, plus one for the starting period.
        // A single day in a semi-monthly period counts as that whole period.
        const startDay = startDate.getDate();
        const endDay = endDate.getDate();
        const startPeriod = startDay <= 15 ? 1 : 2;
        const endPeriod = endDay <= 15 ? 1 : 2;
        return (endDate.getFullYear() - startDate.getFullYear()) * 24
          + (endDate.getMonth() - startDate.getMonth()) * 2
          + (endPeriod - startPeriod) + 1;
      default:
        // Unknown/unset frequency — treat the units as covering the period once.
        return 1;
    }
  }

  /** Per-occurrence units × occurrences implied by the frequency. */
  computeTotalAuthUnits(): number {
    const form = this.authorizationsForm;
    const perOccurrence = Number(form?.get('units')?.value ?? 0) || 0;
    const count = this.getFrequencyPeriodCount(
      form?.get('authFrequencyLkp')?.value,
      form?.get('startDate')?.value,
      form?.get('endDate')?.value
    );
    // Units can be fractional once divided into quarter hours; keep 2dp to avoid float noise.
    return Math.round(perOccurrence * count * 100) / 100;
  }

  /**
   * Writes the computed total into the disabled totalAuthUnits control. getRawValue() is what
   * feeds the save/update payload, so a disabled control still reaches the API.
   */
  private applyTotalAuthUnits(): void {
    this.authorizationsForm
      ?.get('totalAuthUnits')
      ?.setValue(this.computeTotalAuthUnits(), { emitEvent: false });
  }

  /**
   * "Total Authorized Dollars" is always derived from Authorized Dollars × frequency, so it must
   * never be typed into. The form-level enable() calls in ngOnChanges re-enable every control, so
   * this has to run again after each of them.
   */
  private lockCalculatedFields(): void {
    this.authorizationsForm?.get('totalAuthUnits')?.disable({ emitEvent: false });
  }

  patchAuthDetails() {
    // ngOnChanges fires before ngOnInit, so authData can arrive before the FormGroup exists. Every
    // patch below is optional-chained, which would silently no-op — remember it and re-run once
    // ngOnInit has built the form and loaded the lookups.
    if (!this.authorizationsForm) {
      this.patchPending = true;
      return;
    }
    this.patchPending = false;

    // API call to fetch the details and patch form
    this.isPatching = true;
    console.log('auth data', this.authData, this.authData?.primaryDiagnosisId1Value);
    // The hours/minutes inputs describe ONE occurrence, so rebuild them from `periodUnits` (quarter-hour
    // units per occurrence) — the inverse of timeToUnits. totalAuthUnits can no longer be parsed as
    // HHMM here: it now carries the frequency-multiplied total.
    const perOccurrenceUnits = Number(this.authData?.periodUnits ?? 0) || 0;
    const totalHrs = Math.floor(perOccurrenceUnits / 4);
    const totalMins = ((perOccurrenceUnits % 4) * 15).toString().padStart(2, '0');
    if (this.authorizationsForm !== undefined && this.authData?.authFrequencyLkp === 'Daily') {
      const dailyUnitsArray = this.authorizationsForm.get('dailyUnits') as FormArray;
      this.daysOfWeek.forEach((day, index) => {
        const apiKey = `${day.toLowerCase()}Hrs`;
        const timeString = this.authData[apiKey];
        if (timeString !== null && timeString !== undefined) {
          let totalMins = '00';
          let totalHrs = '0';
          const timeStr = timeString.toString().replace(':', '');
          if (timeStr.length === 1 || timeStr.length === 2) {
            totalHrs = '00';
            totalMins = timeStr.padStart(2, '0');
          }
          else if (timeStr.length >= 3) {
            totalHrs = timeStr.slice(0, -2);
            totalMins = timeStr.slice(-2);
          }

          const formGroup = dailyUnitsArray.at(index) as FormGroup;
          formGroup.patchValue({
            hours: totalHrs,
            minutes: totalMins
          });
        }
      });
    }

    const existingSpendingPlan = this.spendingPlans.filter(plan => plan.clientAuth === this.authData?.clientAuth);

    const formValuesToPatch = {
      ...this.authData,
      clientAuth: existingSpendingPlan.length > 0 ? existingSpendingPlan[0].clientAuth : null,
      serviceCode: this.authData?.serviceCodeId ?? this.authData?.serviceCode,
      planId: this.authData?.planIdLkp,
      serviceDescription: this.authData?.serviceDescription,
      orgName: this.authData?.orgId,
      // The form's `units` control is "Authorized Dollars" — the per-occurrence figure. The backend
      // now returns that as periodUnits and keeps `units` for its own (total) meaning, so patch
      // from periodUnits rather than units.
      units: this.authData?.periodUnits,
      // Explicit rather than relying on the spread: the AFT dropdown binds lkpValueName, and a
      // null/absent value from the API would blank the control instead of leaving the default.
      authFrequencyLkp: this.authData?.authFrequencyLkp || this.AUTH_FREQUENCY.ENTIRE_PERIOD,
      carryoverUnits:
        this.authData?.carryoverUnits === true
          ? 'Yes'
          : this.authData?.carryoverUnits === false
            ? 'No'
            : this.authData?.carryoverUnits,
    };

    this.authorizationsForm?.patchValue(formValuesToPatch);

    var val = this.authorizationsForm?.get("weeklyAuthUnitsPartB")?.value;
    // Gate on the per-occurrence units now that hrs/mins are derived from them rather than from
    // the totalAuthUnits HHMM string.
    if (perOccurrenceUnits > 0) {
      this.authorizationsForm?.patchValue({
        totalAuthUnitsHrs: totalHrs,
        totalAuthUnitsMin: totalMins
      })
    }
    // Recompute from the patched frequency + dates so an untouched edit still sends a correct total.
    this.applyTotalAuthUnits();
    this.isPatching = false;
  }

  updateMinStartDate(): void {
    const endDate = this.authorizationsForm.get('endDate')?.value;
    if (endDate instanceof Date) {
      const nextDay = new Date(endDate);
      nextDay.setDate(nextDay.getDate() - 1);
      this.minStartDate = nextDay;
    } else {
      this.minStartDate = undefined;
    }
  }

  updateMaxEndDate(): void {
    const startDate = this.authorizationsForm.get('startDate')?.value;
    if (startDate instanceof Date) {
      const nextDay = new Date(startDate);
      nextDay.setDate(nextDay.getDate() + 1);
      this.maxEndDate = nextDay;
    } else {
      this.maxEndDate = undefined;
    }
  }

  disabledStartDate = (startValue: Date): boolean => {
    const endDate = this.authorizationsForm.get('endDate')?.value;
    if (!startValue || !endDate || !(endDate instanceof Date)) {
      return false;
    }
    console.log("startval", startValue, endDate, endDate instanceof Date, startValue.getTime() > endDate.getTime())

    return startValue.getTime() > endDate.getTime();
  };

  disabledEndDate = (endValue: Date): boolean => {
    const startDate = this.authorizationsForm.get('startDate')?.value;
    if (!endValue || !startDate || !(startDate instanceof Date)) {
      return false;
    }
    return endValue.getTime() <= startDate.getTime();
  };

  disableFieldsForEdit() {
    const fieldsToKeepDisabled = [
      'consumerFirstName',
      'consumerLastName',
      'medicaid',
      'consumerPPLId',
      'decisionBy',
      'sourceDetail',
      'statusLkp',
      'decisionComments',
      'planId',
      'authFrequencyLkp',
      'serviceAdminLkp',
      'estimatedFirstWeekUnits',
      'estimatedMidWeekUnits',
      'estimatedLastWeekUnits',
      'weeklyAuthUnitsFormatted',
    ];

    if (this.authData?.statusLkp) {
      fieldsToKeepDisabled.push('serviceCode');
    }

    if (!this.canEditSpendingPlan) {
      fieldsToKeepDisabled.push('clientAuth');
    }

    const formControls = Object.keys(this.authorizationsForm.controls);

    formControls.forEach((control) => {
      if (fieldsToKeepDisabled.includes(control)) {
        this.authorizationsForm.get(control)?.disable();
      }
    });
  }

  diagnosisCodeSelected(data: any) {
    if (this.dialogId) {
      this.dialogSvc.closeDialog(this.dialogId);
      this.dialogId = null;
    }
    const codeValue = `${data.control}Value`
    this.authorizationsForm.get(codeValue)?.setValue(data.code?.description);
    this.authorizationsForm.get(data.control)?.setValue(data.code?.diagnosisDetailId);
  }

  openSearchDisgnosisCodePopup(code: string) {
    this.control = code;
    const dialogConfig: DialogConfig = {
      title: 'Search Diagnosis Code',
      okText: 'Ok',
      size: 'large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogId = this.dialogSvc.openDialog(
      this.diagnosisListDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  openAddSpendingPlanPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Add Spending Plan',
      okText: 'Ok',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.addDialogId = this.dialogSvc.openDialog(
      this.addAuthSpendingPlan,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  handleCancel() {
  }

  onCreateSpendingPlan() {
    if (!this.spendingPlan || this.spendingPlan.trim() === '') {
      return;
    }

    const existingPlan = this.spendingPlans.filter(plan => plan.clientAuth.toLowerCase() === this.spendingPlan.toLowerCase());
    if (existingPlan.length == 0) {
      this.spendingPlans = [...this.spendingPlans, { id: this.spendingPlan, clientAuth: this.spendingPlan }];
    }

    this.authorizationsForm.get('clientAuth')?.setValue(this.spendingPlan);
    this.spendingPlan = '';
    if (this.addDialogId) {
      this.dialogSvc.closeDialog(this.addDialogId);
      this.addDialogId = null;
    }
  }

  onConsumerSearch() {
    const formData = this.authorizationsForm.value;
    const from = '';
    console.log('formData', formData);
    this.showSearchError = !(
      formData.consumerFirstName.trim() !== '' ||
      formData.consumerLastName.trim() !== '' ||
      formData.medicaid.trim() !== '' ||
      formData.consumerPPLId.trim() !== ''
    );
    // this.showConsumersList = !this.showSearchError;
    if (!this.showSearchError) {
      const payload = this.buildRequestPayload();
      this.listService.getListData(payload, from).subscribe((data: any) => {
        console.log('search data', data);
        this.gridData = data.responsedata;
        this.gridData.forEach((consumer: any) => {
          consumer['arialabel'] = `${consumer.consumerFirstName} ${consumer.consumerLastName} - CIN: ${consumer.medicaid} - PPL ID: ${consumer.consumerPPLId}`
        });
        this.showConsumersList = true;
      });
    }
  }

  buildRequestPayload(event?: any) {
    const formData = this.authorizationsForm.value;
    const payload: any = {
      pageName: 'consumer-search',
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: event ? (event?.startingPageNumber).toString() : '1',
      searchParam: [],
      orderByColumn: [],
      orderBy: [],
    };
    let searchParams = [];
    if (formData.consumerFirstName) {
      searchParams.push({
        jsonPath: 'consumerFirstName',
        value: formData.consumerFirstName.trim(),
        operator: 'contains',
      });
    }

    if (formData.consumerLastName) {
      searchParams.push({
        jsonPath: 'consumerLastName',
        value: formData.consumerLastName.trim(),
        operator: 'contains',
      });
    }

    if (formData.medicaid) {
      searchParams.push({
        jsonPath: 'medicaid',
        value: formData.medicaid.trim().toUpperCase(),
        operator: 'equal',
      });
    }

    if (formData.consumerPPLId) {
      searchParams.push({
        jsonPath: 'consumerPPLId',
        value: formData.consumerPPLId.trim(),
        operator: 'equal',
      });
    }
    payload.searchParam = searchParams;
    return payload;
  }

  async getGridHeaders() {
    try {
      if (this.flow) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.AUTHORIZATIONS_CONSUMER_LIST_HEADERS,
          this.flow
        );
        console.log(tempCols.columns);
        this.cols = tempCols.columns;
      }
    } catch (e) { }
  }

  async getAuthGridHeaders() {
    try {
      if (this.flow) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.AUTHORIZATIONS_LIST_HEADERS,
          this.flow
        );
        console.log(tempCols.columns);
        this.authCols = tempCols.columns;
      }
    } catch (e) { }
  }

  onConsumerSelect() { }

  action(event: GridAction) {
    if (event && event.action === 'add') {
      console.log(event.data);
      this.selectedConsumer = event.data;
      this.isConsumerSelected = true;
      this.mode = 'add';
      this.isNewAuthCreationMode = true;
      this.showConsumersList = false;
      this.getProviders(this.selectedConsumer?.participantId);
      this.getSpendingPlans(this.selectedConsumer?.participantId);
    }
  }

  getSpendingPlans(participantId: number, forcePatch: boolean = false) {
    this.authService.getConsumerAuthList(this.programName, participantId).subscribe({
      next: (response: any) => {
        const data = response?.responsedata ?? [];

        this.spendingPlans = data.filter((auth: ConsumerAuthList, index: number, self: ConsumerAuthList[]) =>
          index === self.findIndex((a) => (
            a.clientAuth === auth.clientAuth
          ))
        );

        if (forcePatch) {
          this.patchAuthDetails();
        }
      }
    });
  }

  onCancelUser() {
    this.isConsumerSelected = false;
    this.selectedConsumer = {};
    this.authorizationsForm.reset();
    this.showAddedAuths = false;
    this.authsInSession = [];
  }

  onAdd() {
    if (this.isExistingAuthUpdate) {
      this.onUpdate();
    } else {
      this.applyTotalAuthUnits();
      this.saveAuthDetails();
    }
  }

  onMoveBackToAddAuth(isReset: boolean) {
    this.isNewAuthSubmitted = false;
    this.isProviderAuthAllocated = false;

    if (isReset) {
      this.authorizationsForm.patchValue({
        clientAuth: ''
      });
    } else {
      this.isExistingAuthUpdate = true;
    }
  }

  onMoveBackToAuthAllocation() {
    this.isProviderAuthAllocated = false;
    this.isNewAuthSubmitted = true;
  }

  navigateToDetailsPage() {
    this.claimsService.clearAuthData();
    this.userService.setLeadEntry('authorizations');
    this.userService.setSelectedLead(this.savedAuthId ?? this.selectedAuth);
    setTimeout(() => {
      this.router.navigate(['/home/authorizations/details/'], { state: { authorizationId: this.savedAuthId ?? this.selectedAuth } });
    }, 200);
  }

  populateDays(dailyHrs: any) {
    this.daysOfWeek.forEach((day, i) => {
      const hours = dailyHrs[i]?.hours || '00';
      const minutes = dailyHrs[i]?.minutes || '00';
      const timeValue = `${hours.toString()?.padStart(2, '0')}${minutes.toString()?.padStart(2, '0')}`;
      this.authorizationsForm.get(`${day.toLowerCase()}Hrs`)?.setValue(timeValue);
    });
  }

  handleAuthorization(formData: any, submitMode: string) {
    // Per-day units (the dailyUnits FormArray) are no longer captured in the UI, so validating them
    // only ever produced errors the user had no field to fix. Total Authorized Dollars is now
    // derived from Authorized Dollars × the frequency instead — see computeTotalAuthUnits().
    // Kept rather than deleted in case the daily grid comes back.
    //
    // let allEmpty = false;
    // const dailyUnits = this.authorizationsForm.get('dailyUnits') as FormArray;
    // let hasInvalidHours = false;
    //
    // if (formData.authFrequencyLkp === 'Daily') {
    //   for (let control of dailyUnits.controls) {
    //     const hoursControl = control.get('hours');
    //
    //     if (hoursControl && hoursControl.invalid) {
    //       hasInvalidHours = true;
    //       break;
    //     }
    //   }
    //   allEmpty = formData?.dailyUnits?.every((item: any) => (!item.hours || item.hours === '00' || item.hours === '0') && (!item.minutes || item.minutes === '00'));
    // }

    try {
      this.validationErrors = performValidation(formData, this.secData, 'Submit', undefined, undefined, this.flow || undefined, this.sectionsService.getEnrollmentType());

      // if (allEmpty) {
      //   newError.unitsInFormatDaily = 'Please enter units for atleast one day';
      // }
      //
      // if (hasInvalidHours) {
      //   newError = {
      //     unitsInFormatDaily: 'Please enter upto 24 hours'
      //   }
      // }

      console.log('validationErrors', this.validationErrors);
    } catch (e) {
      this.logger.debug('Error in validations', e);
    }
    if (submitMode === 'update' && this.authData?.usedUnits != null) {
      const newUnits = Math.round((parseFloat(formData.units) || 0) * 100) / 100;
      const spentUnits = Math.round((parseFloat(this.authData.usedUnits) || 0) * 100) / 100;
      if (newUnits < spentUnits) {
        this.validationErrors = {
          ...this.validationErrors,
          units: 'Adjustment cannot be made as Participant has spent above the amount requested'
        };
      }
    }

    if (Object.keys(this.validationErrors).length === 0) {
      const payload: any = {
        ...formData,
        clientAuth: formData.clientAuth.trim(),
        unittypeLkp: 'DLR',
        startDate: this.datePipe.transform(formData.startDate, 'yyyy-MM-dd'),
        endDate: this.datePipe.transform(formData.endDate, 'yyyy-MM-dd'),
        modifier1: formData.modifierCode1,
        orgId: formData.orgName,
        billableRate: 0,
        planIdLkp: formData.planId,
        carryoverUnits: formData.carryoverUnits === 'Yes' ? true : formData.carryoverUnits === 'No' ? false : formData.carryoverUnits,
      };

      if (submitMode === 'save') {
        payload.participantId = this.selectedConsumer.participantId;
        payload.medicaidId = this.selectedConsumer.medicaid;
        this.saveAuthorization(payload);
      } else if (submitMode === 'update') {
        // Prefer the auth created in this session (add flow → back → update). selectedAuth comes from
        // the shared selected-lead and can still hold a previously viewed auth's id in the add flow.
        payload.authorizationId = this.savedAuthId ?? this.selectedAuth;
        this.updateAuthorization(payload);
      }
    } else {
      return;
    }
  }


  saveAuthorization(payload: any) {
    this.authorizationService
      .saveAuthorization(this.programName, payload, true)
      .subscribe((data: any) => {
        this.savedAuthId = data.responsedata.authorizationId;
        this.consumerAuthData.participantId = this.savedAuthId;
        if (data.status == 200) {
          this.isNewAuthCreationMode = true;
          this.isNewAuthSubmitted = true;
          this.consumerAuthData.units = this.authorizationsForm.value.units;
          // this.authSubmitted.emit(true);
        }
      });
  }

  updateAuthorization(payload: any) {
    this.authorizationService
      .updateAuthorizationDetails(this.programName, payload.authorizationId, payload)
      .subscribe((data: any) => {
        console.log('updated auth', data);
        this.authData = data.responsedata;
        this.consumerAuthData.units = this.authorizationsForm.value.units;
        if (this.isExistingAuthUpdate) {
          this.isNewAuthSubmitted = true;
          this.isExistingAuthUpdate = false;
        } else {
          this.patchAuthDetails();
        }
        this.onCancelUpdate();
      });
  }

  saveAuthDetails() {
    const dailyHrs = this.authorizationsForm.get('dailyUnits')?.value;
    const dailyUnits = this.authorizationsForm.get('dailyUnits') as FormArray;
    this.populateDays(dailyHrs);
    const authData = this.authorizationsForm.getRawValue();
    const { ...formData } = authData;
    const data = { ...this.authorizationsForm.value };

    data.startDate = this.dateFormatter.formatToString(data.startDate);

    if (data.endDate) {
      data.endDate = this.dateFormatter.formatToString(data.endDate);
    }

    // Use the already-formatted local date strings (data.startDate / data.endDate) so any
    // downstream consumer (e.g. ppl-auth-allocation-list) that JSON-stringifies these into a
    // payload doesn't trigger the toISOString() timezone shift.
    this.consumerAuthData = {
      startDate: data.startDate,
      endDate: data.endDate,
      units: this.authorizationsForm.value.units
    };

    this.handleAuthorization(formData, 'save');
  }

  onCancelUpdate() {
    this.validationErrors = {};
    this.authUpdate.emit(true);
  }

  updateAuthDetails() {
    // if the auth is apporved we need to show confirmation popup before allowing update, else directly allow to update the auth details
    if (this.authData?.statusLkp === 'Approved') {
      this.openApprovedAuthConfirmationPopup(null);
    } else {
      this.onUpdate();
    }
  }

  onUpdate() {
    const dailyHrs = this.authorizationsForm.get('dailyUnits')?.value;
    this.populateDays(dailyHrs);
    // Recompute before capturing the payload — this used to zero totalAuthUnits *after*
    // getRawValue(), which sent whatever stale value the form happened to hold.
    this.applyTotalAuthUnits();
    const formData = this.authorizationsForm.getRawValue();
    this.handleAuthorization(formData, 'update');
  }

  onNextClick() {
    this.isProviderAuthAllocated = true;
  }

  viewerValueChange(value: string) {
    const viewerValue = [value][0];
  }

  filesUpdated() {
    console.log('Files List update');
    this.getDocumentsUploaded(true);
  }

  getDocumentsUploaded(hasUpdatedEntry?: boolean) {
    this.sharedService
      .getUploadedFileDetails(
        this.programName,
        this.savedAuthId,
        'auth',
        hasUpdatedEntry
      )
      .subscribe((data: any) => {
        console.log(data);
        this.filedInfo = data?.responsedata;
      });
  }

    openApprovedAuthConfirmationPopup(event: any) {
    const dialogConfig: DialogConfig = {
      title: 'Confirmation',
      okText: 'Submit',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.approvedAuthconfirmationDialog,
      dialogConfig,
      () => this.onUpdate(),
      () => this.handleCancel()
    );
  }
}
